(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ib-quick-entries"] && !Shopify.designMode) return;
  try {
    
/* No JS needed for static rendering */

  } catch(e) { console.error(e); }
})();
})();
